import React from "react";

export const Section = ({ title, children, testid }) => (
  <section className="rounded-3xl bg-[var(--sand)] border border-[var(--border)] p-5 sm:p-7 mb-6" data-testid={testid}>
    <h2 className="font-serif-title text-2xl sm:text-3xl text-[var(--gold)] mb-5">{title}</h2>
    {children}
  </section>
);

export const TextField = ({ label, value, onChange, testid, placeholder }) => (
  <div>
    {label && <label className="block text-sm font-medium text-[var(--ink)] mb-1.5">{label}</label>}
    <input
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      data-testid={testid}
      className="w-full rounded-xl border border-[var(--border)] bg-white/80 px-3.5 py-2.5 text-sm text-[var(--ink)] focus:outline-none focus:ring-2 focus:ring-[var(--gold-light)]"
    />
  </div>
);

export const TextArea = ({ label, value, onChange, testid, placeholder, rows = 3 }) => (
  <div>
    {label && <label className="block text-sm font-medium text-[var(--ink)] mb-1.5">{label}</label>}
    <textarea
      rows={rows}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      data-testid={testid}
      className="w-full rounded-xl border border-[var(--border)] bg-white/80 p-3 text-sm text-[var(--ink)] focus:outline-none focus:ring-2 focus:ring-[var(--gold-light)] resize-y"
    />
  </div>
);

export const SmallBtn = ({ onClick, children, testid, tone = "outline", disabled }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    data-testid={testid}
    className={`inline-flex items-center gap-1.5 text-sm px-3 py-1.5 rounded-full transition-all ${
      disabled
        ? "border border-[var(--border)] text-[var(--beige)] cursor-not-allowed"
        : tone === "solid"
        ? "bg-[var(--gold)] text-white hover:brightness-105"
        : tone === "danger"
        ? "border border-[#B0553B] text-[#B0553B] hover:bg-[#B0553B] hover:text-white"
        : "border border-[var(--gold)] text-[var(--gold)] hover:bg-[var(--gold)] hover:text-white"
    }`}
  >
    {children}
  </button>
);
